import { booleanAttribute, ChangeDetectionStrategy, Component, input } from '@angular/core';

/** Figma Alerts & Notes note block (7781:103151) — title + pre-wrapped body. */
@Component({
  selector: 'eventq-note-section',
  templateUrl: './note-section.html',
  styleUrl: './note-section.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EventqNoteSection {
  readonly title = input.required<string>();
  readonly body = input('');
  readonly loading = input(false, { transform: booleanAttribute });
}
